// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1pvFN","header":"Messages_header__pOG5V"};